/* unplugin-vue-components disabled */import { render } from "./Vote.vue?vue&type=template&id=121b80a8"
import script from "./Vote.vue?vue&type=script&lang=js"
export * from "./Vote.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__